import { useMemo } from "react";
import { useStore } from "ra-core";

import type {
  ColoredLabeledValue,
  CustomFieldDefinitions,
  EmailTemplate,
  DealStage,
  LabeledValue,
  NoteStatus,
} from "../types";
import { defaultConfiguration } from "./defaultConfiguration";

export const CONFIGURATION_STORE_KEY = "app.configuration";

export interface ConfigurationContextValue {
  companySectors: LabeledValue[];
  currency: string;
  dealCategories: LabeledValue[];
  dealPipelineStatuses: string[];
  dealStages: DealStage[];
  noteStatuses: NoteStatus[];
  taskTypes: LabeledValue[];
  title: string;
  darkModeLogo: string;
  lightModeLogo: string;
  eventTypes: LabeledValue[];
  acquisitionChannels: LabeledValue[];
  prospectStates: ColoredLabeledValue[];
  customerStatuses: ColoredLabeledValue[];
  customFields: CustomFieldDefinitions;
  /** Types of the « Staff » partners (extras, internal team). */
  staffTypes: LabeledValue[];
  /** Types of the « Partenaires » partners (suppliers, caterers...). */
  partnerTypes: LabeledValue[];
  /** Shared email texts of the compose window. */
  emailTemplates: EmailTemplate[];
}

export const useConfigurationContext = () => {
  const [config] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
    defaultConfiguration,
  );
  // Merge with defaults so that missing fields in stored config
  // fall back to default values (e.g. when new settings are added)
  return useMemo(() => ({ ...defaultConfiguration, ...config }), [config]);
};

export const useConfigurationUpdater = () => {
  const [, setConfig] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
  );
  return setConfig;
};
